import axios from "axios";

import { notifyError } from "services/toastService";

const apiDomain = import.meta.env.VITE_API_DOMAIN;

const defaultConfig = {
    headers: { "Content-type": "application/json" },
};

class AxiosManager {
    axiosInstance;

    constructor() {
        this.axiosInstance = axios.create({
            baseURL: apiDomain,
            headers: {
                "Access-Control-Allow-Origin": "*",
            },
        });

        this.axiosInstance.interceptors.response.use(
            (response) => response,
            (error) => {
                if (!error?.config?.suppressToast) {
                    notifyError(error);
                }

                return Promise.reject(error);
            },
        );
    }

    setAuthToken(token) {
        this.axiosInstance.interceptors.request.use(
            (config) => {
                if (config.headers && token) {
                    config.headers.Authorization =
                        config.headers.Authorization || token;
                }

                return config;
            },
            (error) => Promise.reject(error),
        );
    }

    request$(url, method, data, config) {
        return new Promise((resolve, reject) => {
            const configMerged = { ...defaultConfig, ...config };

            this.axiosInstance
                .request({
                    ...configMerged,
                    url,
                    method,
                    data,
                })
                .then(resolve)
                .catch(reject);
        });
    }

    get$(url, config) {
        return this.request$(url, "get", null, config);
    }

    post$(url, args, config) {
        return this.request$(url, "post", args, config);
    }

    put$(url, args, config) {
        return this.request$(url, "put", args, config);
    }

    patch$(url, args, config) {
        return this.request$(url, "patch", args, config);
    }

    head$(url) {
        return this.request$(url, "head");
    }

    delete$(url) {
        return this.request$(url, "delete");
    }
}

const axiosManager = new AxiosManager();

export default axiosManager;
